import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import SearchBox from '@root/modules/Sellers/Inquiry/components/Search';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import DropdownAction from '@root/modules/Warehouse/Shared/Actions/DropdownAction';
import { DatePicker, Menu, Table } from 'antd';
import forwardingService from '../../services';
import { useEffect, useState } from 'react';

const ForwarderInbound = () => {
  const history = useHistory();
  const breadcrumbList = [
    { tittle: 'Inbound', url: '' },
    { tittle: 'Inbound List', url: '' }
  ];
  const [search, setSearch] = useState('');
  const [searchBy, setSearchBy] = useState('');
  const [list, setList] = useState();
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [date, setDate] = useState<[string, string]>();
  const fetchData = async () => {
    const res = await forwardingService.getInboundList(
      currentPage,
      searchBy,
      search,
      date?.[0],
      date?.[1]
    );
    setList(res.res);
    setTotal(res.count);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchBy, search, date]);
  const [sort, setSort] = useState(true);
  const [label, setLabel] = useState({
    key: '1',
    label: 'Select'
  } as any);

  const sortedData = list
    ? [...list].sort((a: any, b: any) => {
        if (!sort) {
          return (
            new Date(a.startedAt).getTime() - new Date(b.startedAt).getTime()
          );
        } else {
          return (
            new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime()
          );
        }
      })
    : [];
  const columns = [
    {
      title: 'No',
      dataIndex: 'id'
    },
    {
      title: 'Seller Name',
      dataIndex: 'seller',
      render: (seller: any) => {
        return seller.companyName;
      }
    },
    {
      title: 'Seller E-mail Address',
      dataIndex: 'seller',
      render: (seller: any) => {
        return seller.email;
      }
    },
    {
      title: 'Product Name',
      dataIndex: 'quotation',
      render: (quotation: any) => {
        return quotation?.products[0]?.productName || '-';
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quotation',
      render: (quotation: any) => {
        return quotation?.products[0]?.stockQuantity === 0
          ? '0'
          : quotation?.products[0]?.stockQuantity || '-';
      }
    },
    {
      title: 'Status',
      dataIndex: 'status'
    },

    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'startedAt'
    }
  ];
  const getSelect = (e: any) => {
    setSearchBy(e.key);
    setLabel({ key: e.key, label: e.domEvent.target.innerText });
  };
  const menu = [
    {
      id: 1,
      titleSelect: 'Select',
      list: (
        <Menu
          onClick={getSelect}
          items={[
            {
              label: 'Seller Name',
              key: 'seller.name'
            },
            {
              label: 'Product Name',
              key: 'product.name'
            }
          ]}
        />
      )
    }
  ];

  console.log(list);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <div style={{ display: 'flex', gap: 8 }} className="control">
          <DatePicker.RangePicker
            onChange={(date: any, dateString: [string, string]) => {
              setDate(dateString);
            }}
            style={{ marginRight: 0 }}
            placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
            format={'YYYY-MM-DD'}
          />
          {menu.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={label.label}
                list={item.list}
              />
            );
          })}
          <SearchBox type onChange={(e: any) => setSearch(e.target.value)} />
        </div>
        <div className="table">
          <div>
            <div className="table__head" style={{ padding: '1rem' }}>
              <span style={{ marginLeft: 8 }}>
                Total Inbound {total ? total : '00'}
              </span>
            </div>

            <Table
              // loading={loading}
              columns={columns}
              dataSource={sortedData}
              pagination={{
                total: total,
                pageSize: 10,
                showSizeChanger: false,
                onChange: (page, limit) => {
                  setCurrentPage(page);
                }
              }}
              onRow={(item) => {
                return {
                  onClick: () => {
                    history.push(`/admin/forwarder/inbound/${item.id}`);
                  }
                };
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForwarderInbound;
